export const themeColors = {
  alpha50: 'rgba(17, 17, 17, 0.5)',
  // in use
  bg: '#F7F8FA',
  black: '#111111',
  black_65: 'rgba(29, 29, 27, 0.65)',
  black_80: 'rgba(29, 29, 27, 0.8)',
  blue: '#15BEF0',
  blue_10: 'rgba(21,190,240, 0.10)',
  blue_65: 'rgba(21,190,240, 0.65)',
  blue_80: 'rgba(21,190,240, 0.8)',
  //
  coolGrey: '#a2aaad',
  // in use
  darkBlue: '#04337C',
  darkBlue_65: 'rgba(4,51,124, 0.65)',
  //
  darkGreen: '#025740',
  darkGrey: '#303030',
  darkRed: '#a20c16',
  darkSkyBlue: '#56b7e6',

  darkYellow: '#FFA751',
  // in use
  gray: '#F7F8FA',
  gray_10: '#f7f8fa',
  gray_12: '#E6E6E7',
  gray_15: '#F0F0F0',
  gray_18: '#acaeaf',
  gray_20: '#848586',
  gray_30: '#4B4D4F',
  green: '#28DC58',
  // /
  grey: '#AFB1B6',
  greyLight: '#EEE',
  // in use
  lightBlue: '#EBF9FF',
  lightGreen: '#B9F2C8',
  //
  lightGrey: '#D8D8DA',
  lightOrange: '#F8CFA8',

  lightPurple: '#801EFF',
  oceanBlue: '#0067b9',
  // in use
  orange: '#f68315',
  //
  primary: '#0057B8',
  // in use
  purple: '#AE8AF3',
  //
  // in use
  red: '#FD4245',
  red_10: '#FFF4F4',
  red_20: '#FEBBBC',
  //
  redPink: '#e40046',
  // in use
  silver: '#d0d3d4',
  silver_20: 'rgba(208, 211, 212, 0.2)',
  silver_40: 'rgba(208, 211, 212, 0.4)',
  silver_50: 'rgba(208, 211, 212, 0.5)',
  silver_70: 'rgba(208, 211, 212, 0.7)',
  //
  silverTwo: '#dee0e0',
  spinnerColor: '#3f51b5',
  starYellow: '#ffb400',

  steelGrey: '#7c878e',
  stroke: '#EAEAEA',
  turquoise: '#15BEF0',
  turquoiseBlue: '#00a5bd',
  turquoiseDark: '#05a1d0',
  turquoiseLight: '#bce1ec',
  white: '#FFFFFF',

  whiteGray: '#f6f6f6',
  whiteGray2: '#d8d8d8',
  // in use
  yellow: '#f4dd63',
  //
  yellow76: 'rgba(252,250,234,0.76)',
} as const;
